// ISO-4217 currency code → ISO-3166 alpha-2 country code, for flag rendering.
// ISO-4217 codes are built as [2-letter ISO-3166 country][currency initial],
// so the first two letters ARE the country code (AED→AE, INR→IN, GBP→GB,
// USD→US, EUR→EU). No per-currency overrides needed.
//
// Supranational / multi-country codes (X…) map to no single country flag.
const NO_FLAG = new Set(["XAF", "XOF", "XCD", "XPF", "XDR"]);

export function currencyToCountryCode(
  code: string | null | undefined,
): string | null {
  if (!code) return null;
  const upper = code.trim().toUpperCase();
  if (upper.length < 2 || NO_FLAG.has(upper)) return null;
  return upper.slice(0, 2);
}
